import { Borrower } from './borrower';

export interface Ccr {
  borrower?: Borrower;
  reportDate?: string;
}

export interface CcrListElement {
  id: number;
  time: Date;
  _expandable: {
    civilId: string;
    data: string;
    requesterEmail: string;
    requesterId: string;
    requesterName: string;
    source: string;
    status: string;
    type: string;
  };
}

export enum CcrReportTypes {
  ECR = 'ecr',
  CCR = 'ccr',
  CCR_REQUESTS = 'ccr_requests'
}
export enum CcrSourceTypes {
  DEFAULT = 'DEFAULT',
  DG = 'DG',
  BNB = 'BNB'
}
export enum NssiSourceTypes {
  DEFAULT = 'DEFAULT',
  DG = 'DG',
  NSSI = 'NSSI'
}

export const DYNAMIC_CCR_SUMMARY_VARIABLES = [
  "banksHasOverdueOver90Days",
  "banksOverdueOver90Sum",
  "banksOverdueOver90Percent",
  "banksHasOverdueOver30Days",
  "banksOverdueOver30Sum",
  "banksOverdueOver30Percent",
  "nonbanksHasOverdueOver90Days",
  "nonbanksOverdueOver90Sum",
  "nonbanksOverdueOver90Percent",
  "nonbanksHasOverdueOver30Days",
  "nonbanksOverdueOver30Sum",
  "nonbanksOverdueOver30Percent"
];
